import { makeVar } from "@apollo/client";

export const NETWORK_STATE = {
  WAITING: 0,
  ERROR: 100,
  OK: 200,
};

export const setNetworkState = makeVar(NETWORK_STATE.OK);
